import { render, staticRenderFns } from "./RequestApproveDialog.vue?vue&type=template&id=4d9aeaca"
import script from "./request-approve-dialog.ts?vue&type=script&lang=ts&external"
export * from "./request-approve-dialog.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports